import { render } from "./App.vue?vue&type=template&id=862ced78"
const script = {}

import "./App.vue?vue&type=style&index=0&id=862ced78&lang=css"
script.render = render

export default script